export default __webpack_public_path__ + "static/medium-image-norsk-1-11e40367ee73d6b8b9177dd010e3e061.png";